import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { inject } from 'vue'

export const useAppInsights = () => {
  return inject('$appInsights') as ApplicationInsights
}
